import { AppEnv } from "./constants";
var env = process.env.NODE_ENV || AppEnv.DEVELOPMENT;
export var getEnv = function () { return env; };
var appEnv = process.env.CO_ENV || AppEnv.DEVELOPMENT;
export var getAppEnv = function () { return appEnv; };
export var isProdEnv = env === AppEnv.PRODUCTION || env === AppEnv.STAGING;
export var isDevEnv = env === AppEnv.DEVELOPMENT;
export var isStgEnv = env === AppEnv.STAGING;
//# sourceMappingURL=index.js.map